const { handleParam, setParamInSession } = require('./paramsHandler');

const IS_QA_KEY = 'isqa';

async function handleIsqa() {
  const method = (paramKey, paramFromUrl) => {
    console.log('isqa will be set in session storage.');
    setParamInSession(paramKey, paramFromUrl);
  };

  return await handleParam(IS_QA_KEY, method, {});
}

module.exports = {
  handleIsqa,
  IS_QA_KEY,
};
